module.exports = __webpack_public_path__ + "img/filter_list_white.ae854bac.svg";